import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import BoostArea from "../components/BoostArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const FundBoost = () => {
  return (
    <>
      <SEO canonical="/funding/boost" {...PAGES["/funding/boost"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Boost"} />

      {/* Service Details Area */}
      <BoostArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default FundBoost;
